import { __assign, __extends } from "tslib";
import { deepMix } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
/**
 * 柱形图
 */
var Column = /** @class */ (function (_super) {
    __extends(Column, _super);
    function Column() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 图表类型 */
        _this.type = 'column';
        return _this;
    }
    /**
     * 获取 柱形图 默认配置
     */
    Column.prototype.getDefaultOptions = function (options) {
        var _a;
        var isRange = options.isRange, label = options.label, yField = options.yField, xField = options.xField;
        return deepMix({}, _super.prototype.getDefaultOptions.call(this), {
            label: label && isRange
                ? __assign({ content: function (item) {
                        var _a;
                        return (_a = item[yField]) === null || _a === void 0 ? void 0 : _a.join('-');
                    } }, label) : label,
            tooltip: {
                shared: true,
                showMarkers: false,
                offset: 20,
            },
            interactions: [{ type: 'active-region' }],
            meta: (_a = {},
                _a[xField] = {
                    type: 'cat',
                },
                _a),
        });
    };
    /**
     * 获取 柱形图 的适配器
     */
    Column.prototype.getSchemaAdaptor = function () {
        return adaptor;
    };
    return Column;
}(Plot));
export { Column };
//# sourceMappingURL=index.js.map